<script setup lang="ts">
import { storeToRefs } from "pinia";
import { onMounted } from "vue";
import { useNaviStore } from "@/stores/navigation-state";

const navigationStore = useNaviStore();
const { html, hideNavigation } = storeToRefs(navigationStore);

onMounted(async () => {
  await navigationStore.getNavigationHtml();

  const toggleCoreNaviMenuAccount = () => {
    let el = document.getElementById("menu-account-dropdown");
    if (el) {
      if (!el.style.display || el.style.display == "none") {
        el.style.display = "block";
      } else {
        el.style.display = "none";
      }
    }
  };

  let obj = document.getElementById("menu-account");
  if (obj) {
    obj.onclick = function () {
      toggleCoreNaviMenuAccount();
    };
  }
  obj = document.getElementById("nav-shortName");
  if (obj) {
    obj.onclick = function () {
      toggleCoreNaviMenuAccount();
    };
  }
});
</script>

<template>
  <div id="clubhouse-navbar" v-html="html" v-if="!hideNavigation"></div>
</template>
